import Component from "@ember/component"
import { action, computed, get } from "@ember/object"
import PromiseProxyMixin from "@ember/object/promise-proxy-mixin"
import ObjectProxy from "@ember/object/proxy"
import { later } from "@ember/runloop"
import { inject as service } from "@ember/service"
import { isNone } from "@ember/utils"
import FindDoc from "cc-frontend/helpers/find-doc"
import { use } from "ember-could-get-used-to-this"
import _ from "lodash"

class ObjectPromiseProxy extends ObjectProxy.extend(PromiseProxyMixin) {}

export default class SearchModal extends Component {
  @service
  rpc

  @service("ember-store")
  store

  init() {
    super.init(...arguments)
    var ids = []

    if (!_.isEmpty(this.courseStandardSetIds)) {
      ids = _.compact(this.courseStandardSetIds)
    }

    if (_.isEmpty(ids) || isNone(ids)) {
      ids = ["blank"]
    }

    // We clone so we're not manipulating the exact array and thus can compare later if
    // we changed it.
    this.set("standardSetIds", _.clone(ids))
    this.set("shadowStandards", _.cloneDeep(this.standards || []))
  }

  @use jurisdictions = new FindDoc(() => ["standard-jurisdiction-index", "index"])

  @computed("shadowStandards.@each.id")
  get selectedStandardIds() {
    return _.map(this.shadowStandards, "id")
  }

  @computed("standardSetIds.[]", "courseId")
  get hierarchicalStandardsReport() {
    let courseId = get(this, "courseId")
    let standardSetIds = _.reject(get(this, "standardSetIds"), (id) => _.includes(id, "blank"))
    if (courseId && standardSetIds.length > 0) {
      return ObjectPromiseProxy.create({
        promise: get(this, "rpc")
          .execute("STANDARDS_REPORT", [courseId], standardSetIds)
          .catch(() => {
            later(() => {
              get(this, "hierarchicalStandardsReport")
            }, 1000)
          }),
      })
    } else {
      return null
    }
  }

  @action
  onCloseModal() {
    this.closeModal({
      standards: this.shadowStandards,
      standardSetIds: _.slice(this.standardSetIds, 0, 5),
    })
  }

  @action
  setStandardSetIds(standardSetIds) {
    this.set("standardSetIds", standardSetIds)
  }

  // The standard model used in Cc is different than what common standards project uses
  // as csp decided on a new schema after we built the first Cc.
  // This is why we use the ID to remove from the set because we don't have to worry
  // about shape of hash matching exactly or identity of object.
  @action
  toggleStandard(standard) {
    if (_.includes(this.selectedStandardIds, standard.id)) {
      var index = _.findIndex(this.shadowStandards, {
        id: standard.id,
      })
      this.shadowStandards.removeAt(index)
    } else {
      this.shadowStandards.pushObject({
        id: standard.id,
        code: standard.altStatementNotation || standard.statementNotation || null,
        grades: standard.standardSet.title,
        subject: standard.standardSet.subject,
        standardSetId: standard.standardSet.id,
        jurisdiction: standard.jurisdiction.title,
        statement: standard.description,
        clarifications: standard.comments,
      })
    }
  }
}
